// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Los dos portales comparten la misma composición: el panel de marca y el
   formulario quedan donde están al cambiar de pestaña (REC-1930). La clase
   receptor-login solo marca el portal, sin cambiar el layout. */

/* Primer chequeo de la sesión: el mismo spinner de página de ProtectedRoute. */
.login-route-checking {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
}
`, "",{"version":3,"sources":["webpack://./src/app/LoginRoute.css"],"names":[],"mappings":"AAAA;;gEAEgE;;AAEhE,+EAA+E;AAC/E;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB","sourcesContent":["/* Los dos portales comparten la misma composición: el panel de marca y el\n   formulario quedan donde están al cambiar de pestaña (REC-1930). La clase\n   receptor-login solo marca el portal, sin cambiar el layout. */\n\n/* Primer chequeo de la sesión: el mismo spinner de página de ProtectedRoute. */\n.login-route-checking {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 60vh;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
